import React from 'react'
import Button from '../../elements/Button'
import globals from '../../globals'
import {
    mapCisToType,
    NETWORK_TELSTRA,
    SERVICE_ADSL,
    SERVICE_FIBRE,
    SERVICE_MOBILE,
    SERVICE_MOBILE_BROADBAND,
    SERVICE_NBN,
    SERVICE_VOIP,
    SERVICE_WIRELESS,
    VOIP_PAYG
} from '../../constants'

const doesDataExist = (plans, itemKey) => {
    let result = false
    plans.forEach(plan => {
        if (plan[itemKey]) {
            result = true
        }
    })

    return result
}

export const Titles = (props) => {
    return (
        <tr>
            <td>{props.existingPlan.title}<br /><small>(current plan)</small></td>
            {props.plans.map((item, key) => {
                return <td key={key} className={props.planSelected(item)} dangerouslySetInnerHTML={{ __html: `${item.title}` + `${item.subHeading ? ` ${item.subHeading}`:``}` }} />
            })}
        </tr>
    )
}

export const Data = (props) => {
    return (
        <tr>
            <td>{props.existingPlan.data}</td>
            {props.plans.map((item, key) => {
                return <td key={key} className={props.planSelected(item)}>{item.data}</td>
            })}
        </tr>
    )
}

export const DataAdditional = (props) => {
    if (!doesDataExist(props.plans, 'dataAdditional')) {
        return null
    }

    if (props.existingPlan.dataAdditional === "") {
        return null
    }

    return (
        <tr>
            <td>{props.existingPlan.dataAdditional}</td>
            {props.plans.map((item, key) => {
                return <td key={key} className={props.planSelected(item)}>{item.dataAdditional}</td>
            })}
        </tr>
    )
}

export const Speeds = (props) => {
    return (
        <tr>
            <td>
                <span className='bold'>{props.existingPlan.speed}</span><br />
                {props.existingPlan.eveningSpeed ? <small>{props.existingPlan.eveningSpeed} Evening speed 7-11pm</small> : ''}
            </td>
            {props.plans.map((item, key) => {
                return (
                    <td key={key} className={props.planSelected(item)}>
                        <span className='bold'>{item.speed}</span><br />
                        {item.eveningSpeed ? <small>{item.eveningSpeed} Evening speed 7-11pm</small> : ''}
                    </td>
                )
            })}
        </tr>
    )
}

export const AdditionalText1 = (props) => {
    return (
        <tr>
            <td>&nbsp;</td>
            {props.plans.map((item, key) => {
                return <td key={key} className={props.planSelected(item)}>{item.additionalText1}</td>
            })}
        </tr>
    )
}

export const AdditionalText2 = (props) => {
    return (
        <tr>
            <td>&nbsp;</td>
            {props.plans.map((item, key) => {
                return <td key={key} className={props.planSelected(item)}>{item.additionalText2}</td>
            })}
        </tr>
    )
}

export const DoubleData = (props) => {
    return (
        <tr className="font-small">
            <td>&nbsp;</td>
            {props.plans.map((item, key) => {
                return <td key={key} className={props.planSelected(item)}>{item.doubleData}</td>
            })}
        </tr>
    )
}

export const Prices = (props) => {
    const formatPrice = (price) => {
        if (price === VOIP_PAYG) {
            return 'Pay-as-you-go'
        }

        if (typeof price === 'object') {
            return price
        }

        return `${globals.addDecimals(price, true)}${props.type !== SERVICE_MOBILE ? '/mth' : ''}`
    }

    const hasSpecial = (item) => {
        return item.special && item.special.planPrice
    }
    const Special = (item) => (
        <React.Fragment>
            <div className='bold font-medium mb-1'>{formatPrice(item.special.planPrice)}</div>
            <small>for {item.special.duration}</small>
            <br />
            <small>then {formatPrice(item.price)} thereafter</small>
        </React.Fragment>
    )
    const Regular = (item) => (
        <span className='bold'>{formatPrice(item.price)}</span>
    )

    const F2fPrice = (item) => (
        <p className="bold">
          {item.title !== "Everyday" && item.title !== "Extra Value" ? (
            <React.Fragment>
              <span className="line-through mr-1">
                  {formatPrice(item.price)}
              </span><br className='d-lg-inline d-xl-none' />
              <span>{formatPrice(item.flipToFibrePriceDiscount)}</span>
            </React.Fragment>
          ) : (
            formatPrice(item.price)
          )}
        </p>
    )

    return (
        <tr>
            <td><span className='bold'>{formatPrice(props.existingPlan.price)}</span></td>
            {props.plans.map((item, key) => {
                return (
                    <td key={key} className={`${props.planSelected(item)} px-0`}>
                        {hasSpecial(item) ? Special(item) : (item.flipToFibrePriceDiscount ? F2fPrice(item) : Regular(item))}
                    </td>
                )
            })}
        </tr>
    )
}

export const PriceNotes = (props) => {
    return (
        <tr>
            <td>&nbsp;</td>
            {props.plans.map((item, key) => {
                return <td key={key} className={`${props.planSelected(item)} font-small`}>{item.priceNotes}</td>
            })}
        </tr>
    )
}

export const PricePerGb = (props) => {
    const calc = (price, data) => {
        return `${globals.addDecimals(parseFloat(price.replace('$', '')) / parseInt(data.replace('GB', '')), true)}/GB`
    }

    return (
        <tr>
            <td><small>{calc(props.existingPlan.price, props.existingPlan.data)}</small></td>
            {props.plans.map((item, key) => {
                return <td key={key} className={props.planSelected(item)}><small>{calc(item.price, item.data)}</small></td>
            })}
        </tr>
    )
}

export const Features = (props) => {
    let hasFeatures = false
    props.plans.forEach(item => {
        if (item.features && item.features.length > 0) {
            hasFeatures = true
        }
    })

    if (!hasFeatures) return false

    return (
        <tr className='font-small'>
            <td>{props.existingPlan.features.map((item, key) => {
                return <React.Fragment key={key}><span dangerouslySetInnerHTML={{ __html: item }} /><br /></React.Fragment>
            })}
            </td>
            {props.plans.map((item, key) => {
                if (item.features && item.features.length > 0) {
                    return (
                        <td key={key} className={props.planSelected(item)}>
                            {item.features.map((item, key) => {
                                return <React.Fragment key={key}><span dangerouslySetInnerHTML={{ __html: item }} /><br /></React.Fragment>
                            })}
                        </td>
                    )
                }

                return <td key={key} className={props.planSelected(item)}>&nbsp;</td>
            })}
        </tr>
    )
}

export const Html = (props) => {
    return (
        <tr className='font-small'>
            <td>{props.existingPlan.html}</td>
            {props.plans.map((item, key) => {
                if (item.html) {
                    return <td key={key} className={props.planSelected(item)}>{item.html}</td>
                }

                return <td key={key} className={props.planSelected(item)}>&nbsp;</td>
            })}
        </tr>
    )
}

export const Terms = (props) => {
    let content = ''
    const totalMinCost = (item) => {
        return globals.addDecimals((item.totalMinCost ? item.totalMinCost : item.price), true)
    }

    return (
        <tr>
            <td>&nbsp;</td>
            {props.plans.map((item, key) => {
                if ([SERVICE_NBN, SERVICE_FIBRE].includes(props.type)) {
                    content = <small>Total minimum cost {props.f2fPromo && (item.title !== 'Everyday' && item.title !== 'Extra Value') ? `$${item.flipToFibrePriceDiscount}` : totalMinCost(item)}</small>
                }

                if (props.type === SERVICE_MOBILE) {
                    if (props.mobileNetwork === NETWORK_TELSTRA) {
                        content = <small>{globals.addDecimals(item.costPerGb, true)}/GB<br />Total min {totalMinCost(item)}</small>
                    } else {
                        content = <small>$10/GB<br />Total min {totalMinCost(item)}</small>
                    }
                }

                if (props.type === SERVICE_MOBILE_BROADBAND) {
                    content = <small>Excess data $10/GB<br />Total min {totalMinCost(item)}</small>
                }

                if (props.type === SERVICE_WIRELESS) {
                    content = <small>Total minimum {totalMinCost(item)} | Data cost ${parseFloat(item.costPerGb).toFixed(2)}/GB | Excess data $10/GB auto-recharge</small>
                }

                if (props.type === SERVICE_ADSL) {
                    content = <small>Total min {totalMinCost(item)}<br /><a href={mapCisToType[props.type]} target='_blank'>Critical information summary</a></small>
                }

                if (props.type === SERVICE_VOIP) {
                    content = <small>Total minimum cost {item.price === VOIP_PAYG ? '$0' : totalMinCost(item)}</small>
                }

                return <td key={key}>{content}</td>
            })}
        </tr>
    )
}

export const Buttons = (props) => {
    const handleSelect = (event, item) => {
        event.preventDefault()
        props.handleSelect(item.id, item)
    }

    return (
        <tr>
            <td>&nbsp;</td>
            {props.plans.map((item, key) => {
                return (
                    <td key={key} className={props.planSelected(item)}>
                        <Button title={props.planSelected(item) ? 'Selected' : 'Select'} action={event => handleSelect(event, item)} />
                    </td>
                )
            })}
        </tr>
    )
}



// WEBPACK FOOTER //
// ./resources/js/components/ComparePlans/DesktopElements.js